<template>
  <v-container
    id="plane-fault-report-view"
    fluid
    tag="section"
  >
    <material-card
      icon="$plane_fault_reports"
      icon-small
      color="accent"
      :title="page_title"
      help="plane-fault-reports"
    >
      <v-card-title>
        <v-btn
          v-show="editor"
          v-shortkey.once="['f2']"
          color="primary"
          class="mb-2 ml-2"
          @shortkey="edit('new')"
          @click="edit('new')"
        >
          {{ $t('new_item',{ item: $t('plane_fault_report') }) }}
        </v-btn>
        <v-spacer />
        <v-switch
          v-model="show_all"
          class="mx-2"
          :label="$t('show_all')"
          hide-details
        />
        <v-text-field
          v-model="search"
          append-icon="$search"
          class="ml-auto"
          hide-details
          :label="$t('search_records')"
          single-line
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          show-expand
          :headers="computed_headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :item-class="row_classes"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="ma-3 pa-6">
              <h3>{{ $t('fields.owner') }}</h3>
              <pre>{{ item.plane.owner[0].name }}</pre>
              <h3>{{ $t('fields.description') }}</h3>
              <pre v-if="item.created_operator">{{ item.created_at | dateTimeFormat }}<br>{{ item.created_operator.name }}: {{ item.description }}</pre>
              <h3>{{ $t('fields.maintenance_comment') }}</h3>
              <pre v-if="item.maintenance_operator">{{ item.updated_at | dateTimeFormat }}<br>{{ item.maintenance_operator.name }}: {{ item.maintenance_comment }}</pre>
            </td>
          </template>
          <template #item.created_at="{item}">
            {{ item.created_at | dateFormat }}
          </template>
          <template #item.sending_at="{item}">
            {{ item.sending_at | dateFormat }}
          </template>
          <template #item.maintenance_status="{item}">
            {{ item.maintenance_status ? $t('types.' + item.maintenance_status.name) : '-' }}
          </template>
          <template #item.actions="{item}">
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :show="!action.disable"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item.id)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'

  export default {
    name: 'PlaneFaultReports',
    components: {
    },
    data () {
      return {
        items: [],
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        show_all: false,
        expanded: [],
        singleExpand: true,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('planeFaultReport/options'),
      search: sync('planeFaultReport/search'),
      headers_data () {
        return [
          {
            hide_small: true,
            text: this.$t('fields.reg_num'),
            align: 'start',
            sortable: true,
            value: 'plane.reg_num',
          },
          {
            hide_small: true,
            text: this.$t('fields.description'),
            align: 'start',
            sortable: true,
            value: 'description',
          },
          {
            hide_small: true,
            text: this.$t('fields.maintenance_status_id'),
            align: 'start',
            sortable: true,
            value: 'maintenance_status',
          },
          {
            text: this.$t('fields.created_at'),
            sortable: true,
            value: 'created_at',
            width: 200,
          },
          {
            text: this.$t('fields.maintenanced_at'),
            sortable: true,
            value: 'maintenanced_at',
            width: 200,
          },
          {
            // text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
            width: 150,
          },
        ]
      },
      actions () {
        return [
          // { color: 'info', icon: '$info' },
          // { color: 'edit', icon: '$edit', tooltip: 'tooltip_edit', func: this.edit, disable: !this.editor },
          { color: 'edit', icon: '$plane_fault_fix', tooltip: 'tooltip_plane_fault_fix', func: this.fix, disable: !this.editor },
        ]
      },
      page_title () { return this.$t('plane_fault_reports') },
      editor () { return true },
      computed_headers () { return this.headers_data.filter(h => h.hide_small !== this.$vuetify.breakpoint.mdAndDown) },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
      show_all: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
    },
    methods: {
      getList: call('planeFaultReport/search'),
      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
            show_all: this.show_all,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      edit (id) {
        let url = ''
        if (id === 'new') {
          url += '/plane-fault/new'
        } else {
          url += `/plane-fault/edit/${id}`
        }
        this.$router.push(url).catch(() => {})
      },
      fix (id) {
        this.$router.push(`/plane-fault/fix/${id}`).catch(() => {})
      },
      row_classes (item) {
        if (!item.plane.functional) {
          return 'red lighten-5'
        } else if (item.maintenance_status === null) {
          return 'white'
        } else if (item.maintenance_status.name === 'functional') {
          return 'green lighten-5'
        } else if (item.maintenance_status.name === 'required_part') {
          return 'orange lighten-5'
        } else if (item.maintenance_status.name === 'awaiting_repair') {
          return 'blue lighten-5'
        } else if (item.maintenance_status.name === 'inoperable') {
          return 'red lighten-5'
        }
      },
    },
  }
</script>
